<template>
  <h1 class="">ثبت نام اولیه سامانه</h1>
  <div class="row">
    <div class="col-12 text-center">
      <RouterLink to="/PhoneNumber" class="btn btn-success px-5">
        ثبت نام
      </RouterLink>
    </div>
  </div>
  <div class="text-center mt-3">
    <span class="sp-danger"> جهت ثبت نام از مرورگرهای  کروم یا  فایرفاکس استفاده نمایید </span>
  </div>
</template>
<style>
.intro-text {
  font-family: Calibri, sans-serif;
}
</style>
<script>

</script>
